// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HintIcon_wrapper__oqJLk","info":"HintIcon_info__gG9bY"};